var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "#3D3D3D",
    stroke: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 92"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36_2",
    cx: 4,
    cy: 4,
    r: 2,
    fill: "#F7F7F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMarker);
export default __webpack_public_path__ + "static/media/pin_marker.8b44abd6335d9f435f0d320a273e36ef.svg";
export { ForwardRef as ReactComponent };